<template>
  <div class="register-content">
    <section
      v-for="(section, index) in pageSections"
      :key="index"
      class="register-content__section"
    >
      <img
        v-if="section.type === 'full'"
        :src="section.src"
        :alt="section.alt"
        class="register-content__slice"
      />

      <div
        v-else-if="section.type === 'columns'"
        class="register-content__cols"
      >
        <img
          v-for="item in section.items"
          :key="item.alt"
          :src="item.src"
          :alt="item.alt"
          class="register-content__slice"
        />
      </div>
    </section>
  </div>
</template>

<script>
import { REGISTER_PAGE_SECTIONS } from '@/constants/registerPage'

export default {
  name: 'RegisterPageContent',
  props: {
    sections: {
      type: Array,
      default: null
    }
  },
  computed: {
    pageSections() {
      return this.sections || REGISTER_PAGE_SECTIONS
    }
  }
}
</script>

<style scoped>
.register-content__section + .register-content__section {
  margin-top: var(--register-section-gap);
}

.register-content__slice {
  width: 100%;
  height: auto;
  display: block;
}

.register-content__cols {
  display: grid;
  grid-template-columns: var(--register-col-ratio);
  gap: 0;
}
</style>
